<div id="communityPolicyDialog" class="mat-dialog-custom community-policy-dialog-container">
  <div class="title-container">
    <button
      id="closeDialog"
      class="close button button-link"
      type="button"
      aria-label="close"
      tabindex="0"
      (click)="onCancel()"
      i18n-aria-label
    >
      <svg-icon src="/assets/icons/close.svg" alt="Close" i18n-alt />
    </button>
  </div>
  <rdx-community-policy />
</div>
